"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  Provide static calls for all methods.
 * 
 *  Instead this: let users = new User().with('country').get()
 *  We can do this: let users = User.with('conutry').get()
 * 
 */

var StaticModel = function () {
  function StaticModel() {
    _classCallCheck(this, StaticModel);
  }

  _createClass(StaticModel, null, [{
    key: "instance",
    value: function instance() {
      return new this();
    }
  }, {
    key: "include",
    value: function include() {
      var self = this.instance();
      self.include.apply(self, arguments);

      return self;
    }
  }, {
    key: "append",
    value: function append() {
      var self = this.instance();
      self.append.apply(self, arguments);

      return self;
    }
  }, {
    key: "select",
    value: function select() {
      var self = this.instance();
      self.select.apply(self, arguments);

      return self;
    }
  }, {
    key: "where",
    value: function where(field, value) {
      var self = this.instance();
      self.where(field, value);

      return self;
    }
  }, {
    key: "whereIn",
    value: function whereIn(field, array) {
      var self = this.instance();
      self.whereIn(field, array);

      return self;
    }
  }, {
    key: "orderBy",
    value: function orderBy() {
      var self = this.instance();
      self.orderBy.apply(self, arguments);

      return self;
    }
  }, {
    key: "page",
    value: function page(value) {
      var self = this.instance();
      self.page(value);

      return self;
    }
  }, {
    key: "limit",
    value: function limit(value) {
      var self = this.instance();
      self.limit(value);

      return self;
    }
  }, {
    key: "custom",
    value: function custom(resource) {
      var self = this.instance();
      self.custom(resource);

      return self;
    }
  }, {
    key: "params",
    value: function params(payload) {
      var self = this.instance();
      self.params(payload);

      return self;
    }
  }, {
    key: "first",
    value: function first() {
      var self = this.instance();

      return self.first();
    }
  }, {
    key: "find",
    value: function find(id) {
      var self = this.instance();

      return self.find(id);
    }
  }, {
    key: "get",
    value: function get() {
      var self = this.instance();

      return self.get();
    }
  }, {
    key: "$get",
    value: function $get() {
      var self = this.instance();

      return self.$get();
    }
  }]);

  return StaticModel;
}();

exports.default = StaticModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-api-query/build/StaticModel.js
// module id = dPBv
// module chunks = 40